module.exports = __webpack_public_path__ + "static/media/Orechova_hora.96666866.md";